// removed by extract-text-webpack-plugin
module.exports = {"customer-list":"app-pages-Customers-CustomerList-ListNonLoyalty-__CustomerList___29Cjl","customer-row":"app-pages-Customers-CustomerList-ListNonLoyalty-__CustomerList___25EZX","left-column":"app-pages-Customers-CustomerList-ListNonLoyalty-__CustomerList___2W8Kl","right-column":"app-pages-Customers-CustomerList-ListNonLoyalty-__CustomerList___26ByS","mk-customer-list":"app-pages-Customers-CustomerList-ListNonLoyalty-__CustomerList___2E1bH","wrapper":"app-pages-Customers-CustomerList-ListNonLoyalty-__CustomerList___1tP5O"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Customers/CustomerList/ListNonLoyalty/CustomerList.css
// module id = 2302
// module chunks = 0